<div class="conditional-formatting-modal">
  <div class="conditional-formatting-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mode-dialog-header>
      <h1 heading>Conditional Formatting</h1>
    </mode-dialog-header>
  </div>
  <div class="content-container">
    <div class="conditional-formatting-info">
      Select a column in your table to apply conditional formatting to. Only measures can be formatted.
    </div>
    <div class="menu-title">Formatted columns</div>
    <div class="conditional-formatting-container">
      <div class="conditional-formatting-item" *ngFor="let column of columns; let i = index">
        <span
          class="color-swatch-container {{ column.selected.value !== '' ? 'selected' : '' }}"
          capraTooltip
          tooltipContent="Select a column to customize colors"
          tooltipPlacement="bottom"
          [tooltipInteractive]="false"
          [tooltipIsDisabled]="column.selected.value !== ''"
          (click)="openModal(i)"
        >
          <mode-color-palette-preview-swatch
            class="color-swatch {{ column.selected.value !== '' ? 'selected' : '' }}"
            [selectedColorPalette]="column.selectedColorPalette"
          ></mode-color-palette-preview-swatch>
        </span>
        <mode-labeled-menu
          class="conditional-formatting-menu"
          buttonHeight="compact"
          menuClass="conditional-formatting-labeled-menu"
          [selected]="column.selected"
          [menuItems]="allColumns"
          [highlighted]="column.highlighted && !isChanged"
          [placeholder]="'Select a column...'"
          (menuChange)="onChangeColorField($event, i)"
        ></mode-labeled-menu>
        <div class="conditional-formatting-select">
          <div
            class="conditional-formatting-icon add-to-bg"
            [ngClass]="{ selected: !column.addToText }"
            (click)="setAddToText(false, i)"
            capraTooltip
            tooltipPlacement="bottom"
            tooltipSize="mini"
            [tooltipContent]="'Apply to background'"
          >
            <capra-icon icon="icon-chart-table"></capra-icon>
          </div>
          <div
            class="conditional-formatting-icon add-to-text"
            [ngClass]="{ selected: column.addToText }"
            (click)="setAddToText(true, i)"
            capraTooltip
            tooltipPlacement="bottom"
            tooltipSize="mini"
            [tooltipContent]="'Apply to text'"
          >
            <capra-icon icon="icon-mark-label"></capra-icon>
          </div>
        </div>
        <div class="remove-column">
          <capra-icon (click)="removeColumn(i)" icon="icon-close"></capra-icon>
        </div>
      </div>
    </div>
    <div class="add-more-columns">
      <capra-button
        [disabled]="allColumns.length === 0 || isAddColumnDisabled"
        size="small"
        variant="secondary"
        color="neutral-green"
        text="Add column"
        icon="icon-plus-large"
        data-test="add-more-columns"
        (clicked)="addMoreColumns()"
        capraTooltip
        tooltipPlacement="bottom"
        tooltipSize="mini"
        [tooltipContent]="'There are no measure columns eligible for conditional formatting'"
        [tooltipIsDisabled]="allColumns.length && !isAddColumnDisabled"
      >
      </capra-button>
    </div>
  </div>
  <div mat-dialog-actions>
    <div>
      <capra-button
        class="action-button"
        text="Cancel"
        variant="secondary"
        color="neutral"
        (clicked)="onCancel()"
      ></capra-button>
    </div>
    <div>
      <capra-button
        class="action-button"
        text="Apply"
        variant="secondary"
        color="neutral"
        data-test="apply-conditional-formatting"
        [disabled]="isApplyDisabled"
        (clicked)="onApply()"
      ></capra-button>
      <capra-button
        class="action-button"
        text="Apply & Close"
        color="default"
        data-test="apply-conditional-formatting"
        [disabled]="isApplyDisabled"
        (clicked)="onApplyAndClose()"
      ></capra-button>
    </div>
  </div>
</div>
